<app-header></app-header>

<div class="container bg-white margin-top-1">
  <!-- Start Filter -->
  <div class="filter-container">
    <div class="row pt-3">
      <!--   <h1 class="header-text-xl pb-4">¿QUÉ QUIERES APRENDER?</h1> -->
    </div>

    <form [formGroup]="form">
      <!-- Start Selector idioma - Materias -->
      <div class="row mb-2">
        <div class="col-md-6">
          <span class="title-filter bold primary">{{ "FIND_YOUR_TEACHER" | translate }}</span>
        </div>
        <div class="col-md-6">
           <!-- Start activar filtro -->
           <button
           type="button"
           color="secondary"
           class="button-show-advanced float-right"
           (click)="showFilter = !showFilter"
           style="max-width: 200px"
         >
           <span class="bold" *ngIf="showFilter"> {{ "hide-filter" | translate }} <i class="fas fa-chevron-up"></i></span>
           <span *ngIf="!showFilter"><i class="fas fa-search-plus"></i></span>
         </button>
         <!-- End activar filtro -->
            <mat-button-toggle-group
              [formControl]="typeLessons"
              style="margin: 0.25em 0"
              class="filter-mat-button-toggle-group  selector-filter float-right">
              <mat-button-toggle value="languages">
                {{ "filter-languages" | translate }}
              </mat-button-toggle>
              <mat-button-toggle value="subjects">
                {{ "schoolar-subjects" | translate }}
              </mat-button-toggle>
               <mat-button-toggle value="others">
              {{ "other-activities" | translate }}
            </mat-button-toggle> 
            </mat-button-toggle-group>
              
        </div>
      </div>
      <div class="row pb-3">

        <!-- Search 
        <div class="col-md-4 col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ "filter-teacher-8" | translate }}</mat-label>
            <input matInput formControlName="search" />
          </mat-form-field>
        </div>-->

        <!-- Lesson -->
        <div class="col-md-4 col-lg-4 col-12">
          <mat-form-field appearance="outline" class="col-md-12 col-12">
            <mat-label>{{ "teacher-of" | translate }}</mat-label>
            <mat-select formControlName="subject" class="bg-white">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="lessonFilterCtrl"
                  [placeholderLabel]="'search' | translate"
                  [noEntriesFoundLabel]="'no-coincidences' | translate"
                >
                </ngx-mat-select-search>
              </mat-option>
              <mat-option
                *ngFor="let lesson of filteredLessons | async"
                [value]="lesson"
              >
                {{ lesson.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- <div class="col d-none d-md-block"></div> -->

        <!-- Level -->
        <div class="col-md-4 col-lg-4 col-12" *ngIf="checkLessonObject">
          <mat-form-field appearance="outline">
            <mat-label>{{ "level" | translate }}</mat-label>
            <mat-select formControlName="levels" multiple class="bg-white">
              <mat-option [value]="level.id" *ngFor="let level of currentLevels"
                >{{ level.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- 4 columna-->
        <div class="col-md-4 col-lg-4 col-12">
          <mat-form-field appearance="outline">
            <mat-label>{{ "also-speaks" | translate }}</mat-label>
            <mat-select formControlName="languagesTeacher">
              <mat-option>
                <ngx-mat-select-search
                  [formControl]="LangMultiFilterCtrl"
                  [placeholderLabel]="'search' | translate"
                  [noEntriesFoundLabel]="'no-coincidences' | translate"
                >
                </ngx-mat-select-search>
              </mat-option>
              <mat-option>--</mat-option>
              <mat-option
                [value]="language.id"
                *ngFor="let language of filteredLangsMulti | async"
                >{{ language.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <!-- Native Speaker -->
          <div class="col-md-12 col-lg-12 col-12">
            <mat-checkbox
              color="primary"
              formControlName="nativeSpiker"
              [disabled]="!form.value.languagesTeacher"
              >{{ "filter-teacher-4" | translate }}</mat-checkbox
            >
          </div>
        </div>
      </div>
      <!-- End Selector idioma - Materias -->
      <!-- Start opciones avanzadas -->

      <div class="row margin-top-2" *ngIf="showFilter">
        <div class="col-md-12">
          <h2>Opciones avanzadas</h2>
        </div>

        <!-- Country -->
        <mat-form-field
          appearance="outline"
          class="col-md-4 col-lg-3 col-12 margin-top-1"
        >
          <mat-label>{{ "filter-teacher-3" | translate }}</mat-label>
          <mat-select formControlName="country">
            <mat-option>
              <ngx-mat-select-search
                [formControl]="countryFilterCtrl"
                [placeholderLabel]="'search' | translate"
                [noEntriesFoundLabel]="'no-coincidences' | translate"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option>--</mat-option>
            <mat-option
              *ngFor="let country of filteredCountryMulti | async"
              [value]="country.id"
            >
              {{ country["name_" + general.translate.currentLang] }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Price -->
        <div class="col-md-4 col-lg-3 col-12">
          <mat-form-field
            appearance="outline"
            class="margin-top-1"
            [matMenuTriggerFor]="menuPrice"
          >
            <mat-label>{{ "filter-teacher-2" | translate }}</mat-label>
            <input matInput formControlName="price" readonly />
          </mat-form-field>
        </div>
        <mat-menu
          #menuPrice="matMenu"
          [hasBackdrop]="true"
          backdropClass="search-teacher-backdrop"
          class="search-teacher-menu"
        >
          <div class="margin-horizontal-1" (click)="$event.stopPropagation()">
            <div class="mat-h4">
              {{ "select-range-price" | translate }}
            </div>
            <ngx-slider
              [(value)]="sliderMinValue"
              [(highValue)]="sliderHighValue"
              [options]="sliderOptions"
              (userChange)="onChangeSlider($event)"
            >
            </ngx-slider>
          </div>
        </mat-menu>

        <!-- Availability -->
        <div class="col-md-4 col-lg-4 col-12">
          <mat-form-field
            appearance="outline"
            class="margin-top-1"
            [matMenuTriggerFor]="menu"
          >
            <mat-label>{{ "filter-teacher-5" | translate }}</mat-label>
            <input matInput formControlName="availability" [readonly]="true" />
          </mat-form-field>
        </div>
        <mat-menu
          #menu="matMenu"
          [hasBackdrop]="true"
          backdropClass="search-teacher-backdrop"
          class="search-teacher-menu"
        >
          <div class="margin-horizontal-1" (click)="$event.stopPropagation()">
            <!-- Hours -->
            <div class="mat-h4">
              {{ "select-range-hours" | translate }}
            </div>
            <div class="row text-center availability-row">
              <div
                class="col-3 availability-range padding-05"
                *ngFor="
                  let availability of availabilityRangesOpt;
                  let i = index
                "
                [ngClass]="{
                  selected: availabilityRanges.indexOf(availability) > -1
                }"
                (click)="onSelectAvailibilityRange(availability)"
              >
                <div>
                  {{ "availability-range-" + i | translate }}
                </div>
                <div class="mat-caption">
                  {{ "availability-text-" + i | translate }}
                </div>
              </div>
            </div>
            <!-- Days -->
            <div class="mat-h4">
              {{ "select-days-week" | translate }}
            </div>
            <div class="row text-center availability-row">
              <div
                class="col availability-day padding-05"
                *ngFor="let availability of availabilityDaysOpt"
                [ngClass]="{
                  selected: availabilityDays.indexOf(availability) > -1
                }"
                (click)="onSelectAvailibilityDay(availability)"
              >
                <div>
                  {{ "availability-day-" + availability | translate }}
                </div>
              </div>
            </div>
          </div>
        </mat-menu>

        <!-- Order -->
        <div
          class="flex-end padding-top-1"
          class="col-md-4 col-lg-4 col-12"
          id="teachers-order"
        >
          <mat-form-field appearance="outline" class="order-field margin-top-1">
            <mat-label>{{ "order-by" | translate }}</mat-label>
            <mat-select [formControl]="order">
              <mat-option
                *ngFor="let order of orderOptions"
                [value]="order.value"
              >
                {{ order.label | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <!-- End opciones avanzadas -->
    </form>
  </div>
  <!-- End Filter -->
</div>

<!-- START CONTENIDO-->
<div
  class="bg-white-blue"
  style="min-height: 58vh; border-top: 1px solid rgb(199, 199, 199)"
>
  <div class="container">
    <!-- Spinner Teachers -->
    <div class="flex-center margin-top-1" *ngIf="loadingTeachersSpinner">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
    </div>

    <!-- Start Teachers Desktop -->
    <div
      class="flex-center-column"
      *ngIf="!general.isMobile(); else mobileTeachersTemplate"
    >
      <mat-card
        *ngFor="let teacher of teachers"
        class="margin-top-1 teacher-card d-flex"
      >
        <div class="row">
          <!-- START columna foto -->
          <div class="col-md-5">
            <!-- Start video -->
              <!-- START novideo -->
              <div *ngIf="!teacher.video_presentation" style="position: relative;">
                <img src="assets/img/no-video-background.jpg" class="img-fluid">
                <div class="centered text-center bold primary">El profesor no ha subido un video todavía</div>

              </div>
              <!-- END novideo -->
            <span *ngIf="teacher.video_presentation">
              <div
                *ngIf="teacher.video_presentation != null"
                style="padding: 56.25% 0 0 0; position: relative"
              >
                <iframe
                  [src]="teacher.video_presentation | domSeguro"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowfullscreen
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  "
                  title=""
                ></iframe>
              </div>
              <script src="https://player.vimeo.com/api/player.js"></script>
            </span>
            <!-- End video -->
          </div>
          <!-- End columna foto -->
          <!-- Start columna datos -->
          <div class="col-md-7">
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-9">
                    <!-- Name & Country -->
                    <div class="">
                      <!-- START Imagen profesor -->
                        <div class="float-left no-photo-background">
                          <div
                            class="over-photo-teacher"
                            *ngIf="teacher.is_premium"
                          >
                            <img
                              class="text-right"
                              src="../../../../assets/img/premium-crown.png"
                            />
                            <p>{{ "premium" | translate }}</p>
                          </div>
                          <!-- Photo -->
                          <img
                            [name]="teacher.photo_url"
                            class="photo-teacher margin-right-05 teacher-col-1"
                            appErrorImage
                            lazy-load
                          />
                        </div>
                      <!-- END Imagen profesor -->
                      <div class="align-middle">
                         <span (click)="openNewTab(teacher.user_id)" class="teacher-name">{{ teacher.name }} {{ teacher.surname }} 
                         
                          <mat-icon
                          *ngIf="teacher.validated"
                          svgIcon="validated"
                          class="validated-icon ml-2"
                          [matTooltip]="'validated-description' | translate"
                          matTooltipPosition="above"
                        >
                        </mat-icon>
                       </span>
                      </div>
                      <!-- Country -->
                      <div class="mt-2">
                        <span class="bold primary">País: </span>
                        <span class="margin-left-05">{{
                          teacher?.country?.name
                        }}</span>
                      </div>
                     
        
                      </div>
                     
                          
                    <!-- Teacher of -->
                    <div class="flex-start-center no-wrap mt-2">
                      <div class="flex-shrink-0">
                        <mat-icon svgIcon="graduation" class="teacher-icon">
                        </mat-icon>
                        <span class="teacher-pretext">
                          {{ "teacher-of" | translate }}:
                        </span>                     
                     
                        <span>
                          {{ teacher?.currentSubject }}
                        </span>
                      </div>
                    </div>
                    
                 
                    <!-- Also Speak -->
                    <div class="flex-start-center no-wrap">
                      <div class="flex-shrink-0">
                        <mat-icon svgIcon="speak" class="teacher-icon">
                        </mat-icon>
                        <span class="teacher-pretext">
                          {{ "speaks" | translate }}:
                        </span>
                      </div>
                      <div class="teacher-lessons margin-left-05">
                        <div
                          *ngFor="
                            let lesson of teacher.languages;
                            let last = last
                          "
                        >
                          {{ lesson?.name }}
                          <span class="language-level">{{ lesson.level }}</span>
                          <span *ngIf="!last">, </span><br>
                      </div>
                      </div>
                    </div>

                    <mat-star-rating
                      *ngIf="!loading"
                      [rating]="teacher.score_average"
                      [starCount]="5"
                      [disabled]="true"
                      color="primary"
                    >
                    </mat-star-rating>
                    <div class="pt-4">
                      <button
                        type="button"
                        color="primary"
                        class="contact-btn blue-button mr-2"
                        (click)="onSendMessage(teacher)"
                      >
                        <i class="far fa-envelope"></i>
                        {{ "contact" | translate }}
                      </button>

                      <button
                        (click)="openNewTab(teacher.user_id)"
                        type="button"
                        color=""
                        class="gradient-button contact-btn"
                      >
                        <i class="fas fa-user-clock"></i>
                        {{ "booking" | translate }}
                      </button>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <!-- Start Precio -->
                    <div
                      class="teacher-price"
                      (click)="openNewTab(teacher.user_id)"
                    >
                      <div class="">
                        <span
                          *ngIf="currency == 'eur' && teacher.price_hour_single"
                          >{{ teacher.price_hour_single }} €</span
                        >
                        <span
                          *ngIf="
                            currency == 'mxn' && teacher.price_hour_single_mxn
                          "
                          >${{ teacher.price_hour_single_mxn }} MXN</span
                        >
                        <span
                          *ngIf="
                            currency == 'usd' && teacher.price_hour_single_usd
                          "
                          >${{ teacher.price_hour_single_usd }} USD</span
                        > /
                        <span
                          *ngIf="
                            !teacher.price_hour_single &&
                            !teacher.price_hour_single_mxn &&
                            !teacher.price_hour_single_usd
                          "
                          >-</span
                        > h.
                        <!-- <span style="font-size: 18px">{{
                          "per-hour" | translate
                        }}</span> -->
                      </div>
                    </div>
                    <!-- End Precio -->
                    
                  </div>
                </div>
              </div>

            </div>
                         
          </div> <!-- Start descripcion -->
                          <div class="p-3 teacher-info-box">
                            {{ teacher.description }}
                          </div>
                          <!-- End descripcion -->
          <!-- End columna datos -->
        </div>
      </mat-card>
    </div>
    <!-- End Teachers Desktop -->
    <div
      class="margin-top-2 padding-2 light-gray text-center"
      *ngIf="teachersLength == 0"
    >
      {{ "no-search-results" | translate }}
    </div>

    <!-- Start Ficha movil profesor-->
    <ng-template #mobileTeachersTemplate>
      <div class="flex-center-column">
        <mat-card
          *ngFor="let teacher of teachers"
          class="margin-top-1 teacher-card"
          (click)="openNewTab(teacher.user_id)"
        >
          <div class="flex-start-center">
            <!-- Photo -->
            <div>
                <!-- START Imagen profesor -->
                <div class="float-left no-photo-background">
                  <div
                    class="over-photo-teacher"
                    *ngIf="teacher.is_premium"
                  >
                    <img
                      class="text-right"
                      src="../../../../assets/img/premium-crown.png"
                    />
                    <p>{{ "premium" | translate }}</p>
                  </div>
                  <!-- Photo -->
                  <img
                    [name]="teacher.photo_url"
                    class="photo-teacher margin-right-05 teacher-col-1"
                    appErrorImage
                    lazy-load
                  />
                </div>
              <!-- END Imagen profesor -->
              <br />
              <mat-star-rating
                *ngIf="!loading"
                [rating]="teacher.score_average"
                [starCount]="5"
                [disabled]="true"
                color="primary"
              >
              </mat-star-rating>
            </div>

            <div class="teacher-col-2">
              <!-- Name & Country -->
              <div class="flex-start-center">
                <div class="mat-subheading-2 margin-bottom-05">
                  {{ teacher.name }}
                  <mat-icon
                    *ngIf="teacher.validated"
                    svgIcon="validated"
                    class="validated-icon"
                    [matTooltip]="'validated-description' | translate"
                    matTooltipPosition="above"
                  >
                  </mat-icon>
                </div>
              </div>
              <div class="mat-subheading-1">
                <span>{{ teacher?.country?.name }}</span>
              </div>
              <div class="flex-start margin-top-1">
                <span *ngIf="currency == 'eur' && teacher.price_hour_single"
                  >{{ teacher.price_hour_single }} €</span
                >
                <span *ngIf="currency == 'mxn' && teacher.price_hour_single_mxn"
                  >${{ teacher.price_hour_single_mxn }} MXN</span
                >
                <span *ngIf="currency == 'usd' && teacher.price_hour_single_usd"
                  >${{ teacher.price_hour_single_usd }} USD</span
                >
                <span
                  *ngIf="
                    !teacher.price_hour_single &&
                    !teacher.price_hour_single_mxn &&
                    !teacher.price_hour_single_usd
                  "
                  >-</span
                >
                {{ "per-hour" | translate }}
              </div>
            </div>
          </div>
          <div class="margin-top-1">
              <!-- Teacher of -->
              <div class="flex-start-center no-wrap mt-2">
                <div class="flex-shrink-0">
                  <mat-icon svgIcon="graduation" class="teacher-icon">
                  </mat-icon>
                  <span class="teacher-pretext">
                    {{ "teacher-of" | translate }}:
                  </span>                     
               
                  <span>
                    {{ teacher?.currentSubject }}
                  </span>
                </div>
              </div>
          
            <!-- Also Speak -->
            <div class="flex-start-center no-wrap">
              <div class="flex-shrink-0">
                <mat-icon svgIcon="speak" class="teacher-icon"> </mat-icon>
                <span class="teacher-pretext">
                  {{ "speaks" | translate }}:
                </span>
              </div>
              <div class="teacher-lessons margin-left-05">
                <span
                  *ngFor="let language of teacher.languages; let last = last"
                >
                  {{ language?.name }}
                  <span class="language-level">{{ language.level }}</span>
                  <span *ngIf="!last">, </span>
                </span>
              </div>
            </div>

            <!-- Start video -->
            <span *ngIf="teacher.video_presentation">
              <div
                *ngIf="teacher.video_presentation != null"
                style="padding: 56.25% 0 0 0; position: relative"
              >
                <iframe
                  [src]="teacher.video_presentation | domSeguro"
                  frameborder="0"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowfullscreen
                  style="
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  "
                  title=""
                ></iframe>
              </div>
              <script src="https://player.vimeo.com/api/player.js"></script>
            </span>
            <!-- End video -->

            <div class="pt-3 teacher-info-box">
              {{ teacher.description }}
            </div>

            <div>
              <button
                type="button"
                color="primary"
                class="contact-btn mr-2 blue-button"
                (click)="onSendMessage(teacher)"
              >
                <i class="far fa-envelope"></i> {{ "contact" | translate }}
              </button>
              <button
                (click)="openNewTab(teacher.user_id)"
                type="button"
                color="primary"
                class="contact-btn gradient-button"
              >
                <i class="fas fa-user-clock"></i> {{ "booking" | translate }}
              </button>
            </div>
          </div>
        </mat-card>
      </div>
    </ng-template>
    <!-- End Ficha movil profesor-->

    <div class="margin-bottom-2">
      <!-- End Teachers -->
      <mat-paginator
        [length]="teachersLength"
        [pageSize]="15"
        *ngIf="teachersLength"
        [pageIndex]="actPage"
        (page)="onChangePage($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
<!-- END CONTENIDO-->
<app-footer></app-footer>
<app-loading [loading]="loading"></app-loading>
